<table>
  <tr>
    @for (column of displayColumns; track column) {
      <th>{{ toUpperCase(column) }}</th>
    }
  </tr>
  @for (data of stagedReceipts; track data; let i = $index) {
    <tr
      [ngClass]="{
        'error-row': !data.ok,
        'success-row': data.ok,
        'odd-row': i % 2 === 1,
      }"
    >
      @for (column of displayColumns; track column) {
        <td>{{ data[column] }}</td>
      }
    </tr>
  }
</table>
